export const getSizeBytes = (str: string) => new TextEncoder().encode(str).length;
